import { Component } from "react";
import ErrorPage from "pages/error/ErrorPage";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    handleRetry = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return <ErrorPage status={500} onRetry={this.handleRetry} />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
